import styled from 'styled-components'

const ControlGroup = styled.div`
  background-color: #f5f5f5;
  margin-top: 10px;
  padding: 15px;
`

export default ControlGroup
